import * as actionTypes from "./actionTypes";
import {firebase} from "../../firebase/index";
import {collections,constants,documents} from "../../firebase/firestoreNameSpaces"
import {generateUniqueId,uploadImage,deleteFileFromUrl} from "../utility"

export const fetchCarouselData = () => {
  return async (dispatch) => {
    
    try{
      dispatch({
        type: actionTypes.FETCH_CAROUSEL_DATA,
        payload: { loading: true },
      });
      let db = firebase.firestore();
      let data = (await db.collection(collections.K5METADATA).doc(documents.CAROUSEL).get()).data();
      let carousel = [];
      for(let id in data){
          carousel.push(data[id])
      }
      dispatch({
        type: actionTypes.FETCH_CAROUSEL_DATA,
        payload: { carouselData: carousel, loading: false },
      });
  }catch(error){
      dispatch({
        type: actionTypes.FETCH_CAROUSEL_DATA,
        payload: { carouselData: null, loading: false },
      });
      return alert(error)
  }
   
  };
};

export const onAddCarousel = (carousel) => {
  return async (dispatch,getState) => {
   
    try{ 
      let carousels = getState().carouselData.carouselData;
      let carouselData = [];
      dispatch({
        type: actionTypes.CAROUSEL_CONTROLS,
        payload: { addBtnLoading: true },
      });
      let image = carousel.imgUrl;
      let {imgTitle,redirectUrl}  = carousel;
      //###########
      let path = `carousel/${generateUniqueId(6)}${image.name}`
      let url =  await uploadImage(path,image);
      let id = generateUniqueId(10)
      let carouselObj = {id:id,imgUrl:url,redirectUrl:redirectUrl,imgTitle:imgTitle}
      let db = firebase.firestore();
      await db.collection(collections.K5METADATA).doc(documents.CAROUSEL)
      .set({[id]:carouselObj},{merge:true})
      if(carousels.length){
          carouselData = [...carousels,carouselObj]
      }else{
        carouselData.push(carouselObj)
      }
        dispatch({
          type: actionTypes.CAROUSEL_CONTROLS,
          payload: { addBtnLoading: false ,carouselData:carouselData},
        });
        // window.location.reload()
      return alert("Carousel Added Successfully")
  }catch(error){
      dispatch({
        type: actionTypes.CAROUSEL_CONTROLS,
        payload: { addBtnLoading: false },
      });
      return alert(error)
  }

  };
};

export const onEditCarousel = (editedCarousel, oldCarouselArray) => {
  return async (dispatch) => {
   
    try{
      dispatch({
        type: actionTypes.CAROUSEL_CONTROLS,
        payload: { carouselBtnLoading: true },
      });

      let id = editedCarousel.id;
      let db = firebase.firestore();
      let carousels = (await db.collection(collections.K5METADATA).doc(documents.CAROUSEL).get()).data();
      for (let ckey in carousels) {
        if (
          ckey != id &&
          carousels[ckey].imgTitle == editedCarousel.imgTitle
        ) {
          dispatch({
            type: actionTypes.CAROUSEL_CONTROLS,
            payload: { carouselBtnLoading: false },
          });
          return alert(
            "Image Title already exists. Please Select Different Image Title"
          );
        }
      }
      if(editedCarousel.image){
        let path = `carousel/${generateUniqueId(6)}${editedCarousel.image.name}`
        let url =  await uploadImage(path, editedCarousel.image);
        await deleteFileFromUrl(editedCarousel.imgUrl)
        editedCarousel.imgUrl = url;
        delete editedCarousel["image"]
      }
     await db.collection(collections.K5METADATA).doc(documents.CAROUSEL)
      .set({[id]:editedCarousel},{merge:true})
      dispatch({
        type: actionTypes.CAROUSEL_CONTROLS,
        payload: { carouselBtnLoading: false },
      });
      window.location.reload()
    }catch(error){

      dispatch({
        type: actionTypes.CAROUSEL_CONTROLS,
        payload: { carouselBtnLoading: false },
      });
      return alert(error)
    }
    
  }; 
};

export const onDeleteCarousel = (carousel) => {
  return async (dispatch,getState) => {
    
    try{
      let carousels = getState().carouselData.carouselData;
      dispatch({
        type: actionTypes.CAROUSEL_CONTROLS,
        payload: { deleteBtnLoading: true },
      });
      
      //########
      let db = firebase.firestore();
      await db.collection(collections.K5METADATA).doc(documents.CAROUSEL).set({[carousel.id]:firebase.firestore.FieldValue.delete()},{merge:true})
      await deleteFileFromUrl(carousel.imgUrl);
      document.getElementById(`cpd${carousel.id}`).click()
      dispatch({
        type: actionTypes.CAROUSEL_CONTROLS,
        payload: { deleteBtnLoading: false,carouselData:carousels.filter(ca=>ca.id!=carousel.id) },
      });
      return alert("Carousel Deleted Successfully")
  }catch(error){
    dispatch({
      type: actionTypes.CAROUSEL_CONTROLS,
      payload: { deleteBtnLoading: false },
    });
      return alert(error)
  }
   
  };
};
 